<template>
  <div class="flex flex-col last:mb-0 mb-4">
    <section
      class="flex items-center justify-between px-8 sm:px-4"
      :class="{ 'mb-2': !selectionRemind }"
    >
      <label class="text-lg">
        {{ name }}
      </label>
      <span
        v-if="isRequired"
        :class="{
          'bg-red-100 text-red-500': !isValid && isDirty,
          'bg-secondary-100 text-secondary-500': !isDirty || hasPassValidation
        }"
        class="px-[6px] py-[2px] rounded-full text-xs"
      >
        必選
      </span>
    </section>
    <span v-if="selectionRemind" class="px-8 sm:px-4 text-gray-500 text-xs">
      {{ selectionRemind }}
    </span>
    <div :class="{ 'bg-secondary-100': isRequired && !isValid && isDirty }">
      <w-radio-group
        v-if="isRadio"
        :name="name"
        :options="items"
        class="px-8 sm:px-4"
        extra-classes="group py-3"
        text-attribute="name"
        value-attribute="index"
        v-model="curSelected"
      >
        <template #label="{ name, price }">
          <div class="flex items-center justify-between">
            <span class="group-hover:text-secondary-500 text-black">
              {{ name }}
            </span>
            <span v-if="price" class="group-hover:text-secondary-400 text-gray-500">
              {{ price | commaFormat | signedPriceFormat }}
            </span>
          </div>
        </template>
      </w-radio-group>
      <w-checkbox-group
        v-else
        :name="name"
        :options="items"
        class="px-8 sm:px-4"
        label-classes="py-3"
        return-object
        text-attribute="name"
        value-attribute="index"
        v-model="curSelected"
      >
        <template #label="item">
          <div class="flex group items-center justify-between w-full">
            <span
              :class="[
                item.disabled ? 'text-gray-300' : 'group-hover:text-secondary-500 text-black'
              ]"
            >
              {{ item.name }}
            </span>
            <span
              v-if="item.price"
              :class="[
                item.disabled ? 'text-gray-300' : 'group-hover:text-secondary-400 text-gray-500'
              ]"
            >
              {{ item.price | commaFormat | signedPriceFormat }}
            </span>
          </div>
        </template>
      </w-checkbox-group>
    </div>
  </div>
</template>

<script>
import MenuItemOption from './MenuItemOption';

export default MenuItemOption;
</script>

<style lang="scss" scoped>
@import 'MenuItemOption';
</style>
